import { render, staticRenderFns } from "./AppScoresNBAStatistics.vue?vue&type=template&id=14a84c08&"
import script from "./AppScoresNBAStatistics.vue?vue&type=script&lang=js&"
export * from "./AppScoresNBAStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports